import { Database } from 'shared/database.enum';
import { Sex } from './sex.enum';

// TODO: These values should really all be just read in from a config file.

export function ensure<T>(argument: T | undefined | null, message: string = 'This value was promised to be there.'): T {
  if (argument === undefined || argument === null) {
    throw new TypeError(message);
  }

  return argument;
}

export const Sexes = [
  { id: '0', value: Sex.Any },
  { id: '1', value: Sex.Male },
  { id: '2', value: Sex.Female },
];

export const WoolTypes = [
  { id: 'MERI_1', value: 'Ultra/Superfine' },
  { id: 'MERI_2', value: 'Fine/Fine-Medium' },
  { id: 'MERI_3', value: 'Medium/Strong' },
];

export const RegisteredStatus = [
  { id: '0', value: 'Any status' },
  { id: '1', value: 'Unregistered' },
  { id: '2', value: 'Registered' },
  { id: '3', value: 'Commercial' },
  { id: '4', value: 'No status' },
];

export const BreederGroupValues = [
  {
    breederGroup: Database.TerminalAll,
    groups:
    [
      { id: '0', value: 'All groups' },
      { id: '2', value: 'Meat Elite' },
      { id: '3', value: 'SuperWhites' },
    ],
  },
  {
    breederGroup: Database.MaternalAll,
    groups:
    [
      { id: '0', value: 'All groups' },
      { id: '1', value: 'SuperBorders' },
    ],
  },
];

export const Breeds = [
  // Terminal - All
  { id: '23', value: 'WHITE SUFFOLK', db: Database.TerminalAll },
  { id: '16', value: 'POLL DORSET', db: Database.TerminalAll },
  { id: '25', value: 'AUSTRALIAN WHITE', db: Database.TerminalAll },
  { id: '39', value: 'BOOROOLA', db: Database.TerminalAll },
  { id: 'CH', value: 'CHAROLLAIS', db: Database.TerminalAll },
  { id: 'CT', value: 'COMPOSITE TERMINALS', db: Database.TerminalAll },
  { id: '05', value: 'COOLALEE', db: Database.TerminalAll },
  { id: '40', value: 'DORPER', db: Database.TerminalAll },
  { id: '33', value: 'DORSET DOWN', db: Database.TerminalAll },
  { id: '04', value: 'DORSET HORN', db: Database.TerminalAll },
  { id: '07', value: 'GROMARK', db: Database.TerminalAll },
  { id: '11', value: 'HAMPSHIRE DOWN', db: Database.TerminalAll },
  { id: '84', value: 'NZ DORSET HORN', db: Database.TerminalAll },
  { id: '86', value: 'NZ POLL DORSET', db: Database.TerminalAll },
  { id: '99', value: 'NZ SOUTHDOWN', db: Database.TerminalAll },
  { id: '88', value: 'NZ STH SUFFOLK', db: Database.TerminalAll },
  { id: '89', value: 'NZ SUFFOLK', db: Database.TerminalAll },
  { id: '87', value: 'NZ TEXEL', db: Database.TerminalAll },
  { id: '34', value: 'RYELAND', db: Database.TerminalAll },
  { id: '35', value: 'SOUTH HAMPSHIRE', db: Database.TerminalAll },
  { id: '21', value: 'SOUTH SUFFOLK', db: Database.TerminalAll },
  { id: '14', value: 'SOUTHDOWN', db: Database.TerminalAll },
  { id: '19', value: 'SUFFOLK', db: Database.TerminalAll },
  { id: '42', value: 'SUFFOLK CANADA', db: Database.TerminalAll },
  { id: '17', value: 'TEXEL', db: Database.TerminalAll },
  { id: '37', value: 'TEXEL DOWNS', db: Database.TerminalAll },
  { id: '24', value: 'ULTRAWHITE', db: Database.TerminalAll },
  { id: '47', value: 'WHITE DORPERS', db: Database.TerminalAll },
  { id: '12', value: 'WILTIPOLL', db: Database.TerminalAll },
  { id: '09', value: 'WILTSHIRE HORN', db: Database.TerminalAll },
  { id: 'XB', value: 'XBRED', db: Database.TerminalAll },
  { id: 'IF', value: 'ILE DE FRANCE', db: Database.TerminalAll },
  // Terminal - Shedders
  { id: '25', value: 'AUSTRALIAN WHITE', db: Database.TerminalShedders },
  { id: 'CS', value: 'COMPOSITE SHEDDING', db: Database.TerminalShedders },
  { id: '40', value: 'DORPER', db: Database.TerminalShedders },
  { id: '24', value: 'ULTRAWHITE', db: Database.TerminalShedders },
  { id: '47', value: 'WHITE DORPERS', db: Database.TerminalShedders },
  { id: '12', value: 'WILTIPOLL', db: Database.TerminalShedders },
  { id: '09', value: 'WILTSHIRE HORN', db: Database.TerminalShedders },
  // Maternal - All
  { id: '02', value: 'BORDER LEICESTER', db: Database.MaternalAll },
  { id: 'CM', value: 'COMPOSITE MATERNALS', db: Database.MaternalAll },
  { id: '15', value: 'COOPWORTH', db: Database.MaternalAll },
  { id: '06', value: 'BOND', db: Database.MaternalAll },
  { id: '39', value: 'BOOROOLA', db: Database.MaternalAll },
  { id: 'CS', value: 'COMPOSITE SHEDDING', db: Database.MaternalAll },
  { id: '03', value: 'CORRIEDALE', db: Database.MaternalAll },
  { id: '49', value: 'DAMARA', db: Database.MaternalAll },
  { id: '38', value: 'EAST FRIESIAN', db: Database.MaternalAll },
  { id: '31', value: 'ENGLISH LEICESTER', db: Database.MaternalAll },
  { id: '43', value: 'FINN LEICESTERS', db: Database.MaternalAll },
  { id: '22', value: 'FINNSHEEP', db: Database.MaternalAll },
  { id: '07', value: 'GROMARK', db: Database.MaternalAll },
  { id: '08', value: 'HYFER', db: Database.MaternalAll },
  { id: '82', value: 'NZ BORDER LEICESTER', db: Database.MaternalAll },
  { id: '75', value: 'NZ COOPWORTH', db: Database.MaternalAll },
  { id: '83', value: 'NZ CORRIEDALE', db: Database.MaternalAll },
  { id: '92', value: 'NZ FINNSHEEP', db: Database.MaternalAll },
  { id: '41', value: 'NZ ROMNEY', db: Database.MaternalAll },
  { id: '32', value: 'PERENDALE', db: Database.MaternalAll },
  { id: '18', value: 'ROMNEY', db: Database.MaternalAll },
  { id: 'SI', value: 'SIL', db: Database.MaternalAll },
  { id: '23', value: 'WHITE SUFFOLK', db: Database.MaternalAll },
  { id: 'XB', value: 'XBRED', db: Database.MaternalAll },
  // Maternal - Corriedale
  { id: '03', value: 'CORRIEDALE', db: Database.MaternalCorriedale },
  { id: '83', value: 'NZ CORRIEDALE', db: Database.MaternalCorriedale },
  // Maternal - First cross sire breeds
  { id: '02', value: 'BORDER LEICESTER', db: Database.MaternalFirstCrossSire },
  { id: '38', value: 'EAST FRIESIAN', db: Database.MaternalFirstCrossSire },
  // Maternal - Prime SAMM
  { id: '48', value: 'PRIME SAMM', db: Database.MaternalPrimeSAMMs },
  // Merino
  { id: '50', value: 'MERINO', db: Database.Merino },
  { id: '60', value: 'POLL MERINO', db: Database.Merino },
  { id: '74', value: 'NZ MERINO', db: Database.Merino },
  { id: '85', value: 'NZ POLL MERINO', db: Database.Merino },
  { id: '71', value: 'NZ MERINO COMPOSITE', db: Database.Merino },
  { id: '90', value: 'NZ POLWARTH', db: Database.Merino },
  { id: '10', value: 'POLWARTH', db: Database.Merino },
  { id: '72', value: 'SOUTH AMERICAN MERINO ', db: Database.Merino },
  // Dohne
  { id: '51', value: 'DOHNE MERINOS', db: Database.Dohne },
  // Dohne
  { id: '36', value: 'GOATS', db: Database.Boer },
  // *TEMA* Starts
  // Lambplan - All
  { id: '25', value: 'AUSTRALIAN WHITES', db: Database.LambplanAll },
  { id: '06', value: 'BOND', db: Database.LambplanAll },
  { id: '39', value: 'BOOROOLA', db: Database.LambplanAll },
  { id: '02', value: 'BORDER LEICESTER', db: Database.LambplanAll },
  { id: 'CH', value: 'CHAROLLAIS', db: Database.LambplanAll },
  { id: 'CM', value: 'COMPOSITE MATERNALS', db: Database.LambplanAll },
  { id: 'CS', value: 'COMPOSITE SHEDDING', db: Database.LambplanAll },
  { id: 'CT', value: 'COMPOSITE TERMINALS', db: Database.LambplanAll },
  { id: '05', value: 'COOLALEE', db: Database.LambplanAll },
  { id: '15', value: 'COOPWORTH', db: Database.LambplanAll },
  { id: '03', value: 'CORRIEDALE', db: Database.LambplanAll },
  { id: '49', value: 'DAMARA', db: Database.LambplanAll },
  { id: '40', value: 'DORPER', db: Database.LambplanAll },
  { id: '33', value: 'DORSET DOWN', db: Database.LambplanAll },
  { id: '04', value: 'DORSET HORN', db: Database.LambplanAll },
  { id: '38', value: 'EAST FRIESIAN', db: Database.LambplanAll },
  { id: '31', value: 'ENGLISH LEICESTER', db: Database.LambplanAll },
  { id: '43', value: 'FINN LEICESTERS', db: Database.LambplanAll },
  { id: '22', value: 'FINNSHEEP', db: Database.LambplanAll },
  { id: '07', value: 'GROMARK', db: Database.LambplanAll },
  { id: '11', value: 'HAMPSHIRE DOWN', db: Database.LambplanAll },
  { id: '08', value: 'HYFER', db: Database.LambplanAll },
  { id: 'IF', value: 'ILE DE FRANCE', db: Database.LambplanAll },
  { id: '82', value: 'NZ BORDER LEICESTER', db: Database.LambplanAll },
  { id: '75', value: 'NZ COOPWORTH', db: Database.LambplanAll },
  { id: '83', value: 'NZ CORRIEDALE', db: Database.LambplanAll },
  { id: '84', value: 'NZ DORSET HORN', db: Database.LambplanAll },
  { id: '92', value: 'NZ FINNSHEEP', db: Database.LambplanAll },
  { id: '86', value: 'NZ POLL DORSET', db: Database.LambplanAll },
  { id: '41', value: 'NZ ROMNEY', db: Database.LambplanAll },
  { id: '99', value: 'NZ SOUTHDOWN', db: Database.LambplanAll },
  { id: '88', value: 'NZ STH SUFFOLK', db: Database.LambplanAll },
  { id: '89', value: 'NZ SUFFOLK', db: Database.LambplanAll },
  { id: '87', value: 'NZ TEXEL', db: Database.LambplanAll },
  { id: '32', value: 'PERENDALE', db: Database.LambplanAll },
  { id: '16', value: 'POLL DORSET', db: Database.LambplanAll },
  { id: '48', value: 'PRIME SAMM', db: Database.LambplanAll },
  { id: '18', value: 'ROMNEY', db: Database.LambplanAll },
  { id: '34', value: 'RYELAND', db: Database.LambplanAll },
  { id: 'SI', value: 'SHEEP IMPROVEMENT LIMITED', db: Database.LambplanAll },
  { id: '35', value: 'SOUTH HAMPSHIRE', db: Database.LambplanAll },
  { id: '21', value: 'SOUTH SUFFOLK', db: Database.LambplanAll },
  { id: '14', value: 'SOUTHDOWN', db: Database.LambplanAll },
  { id: '19', value: 'SUFFOLK', db: Database.LambplanAll },
  { id: '42', value: 'SUFFOLK CANADA', db: Database.LambplanAll },
  { id: '17', value: 'TEXEL', db: Database.LambplanAll },
  { id: '37', value: 'TEXEL DOWNS', db: Database.LambplanAll },
  { id: '24', value: 'ULTRA WHITE', db: Database.LambplanAll },
  { id: '47', value: 'WHITE DORPERS', db: Database.LambplanAll },
  { id: '23', value: 'WHITE SUFFOLK', db: Database.LambplanAll },
  { id: '12', value: 'WILTIPOLL', db: Database.LambplanAll },
  { id: '09', value: 'WILTSHIRE HORN', db: Database.LambplanAll },
  { id: 'XB', value: 'XBRED', db: Database.LambplanAll },
  // CL - Terminal
  { id: '25', value: 'AUSTRALIAN WHITES', db: Database.LambplanTerminal },
  { id: '39', value: 'BOOROOLA', db: Database.LambplanTerminal },
  { id: 'CH', value: 'CHAROLLAIS', db: Database.LambplanTerminal },
  { id: 'CT', value: 'COMPOSITE TERMINALS', db: Database.LambplanTerminal },
  { id: '05', value: 'COOLALEE', db: Database.LambplanTerminal },
  { id: '40', value: 'DORPER', db: Database.LambplanTerminal },
  { id: '33', value: 'DORSET DOWN', db: Database.LambplanTerminal },
  { id: '04', value: 'DORSET HORN', db: Database.LambplanTerminal },
  { id: '07', value: 'GROMARK', db: Database.LambplanTerminal },
  { id: '11', value: 'HAMPSHIRE DOWN', db: Database.LambplanTerminal },
  { id: 'IF', value: 'ILE DE FRANCE', db: Database.LambplanTerminal },
  { id: '84', value: 'NZ DORSET HORN', db: Database.LambplanTerminal },
  { id: '86', value: 'NZ POLL DORSET', db: Database.LambplanTerminal },
  { id: '99', value: 'NZ SOUTHDOWN', db: Database.LambplanTerminal },
  { id: '88', value: 'NZ STH SUFFOLK', db: Database.LambplanTerminal },
  { id: '89', value: 'NZ SUFFOLK', db: Database.LambplanTerminal },
  { id: '87', value: 'NZ TEXEL', db: Database.LambplanTerminal },
  { id: '16', value: 'POLL DORSET', db: Database.LambplanTerminal },
  { id: '34', value: 'RYELAND', db: Database.LambplanTerminal },
  { id: '35', value: 'SOUTH HAMPSHIRE', db: Database.LambplanTerminal },
  { id: '21', value: 'SOUTH SUFFOLK', db: Database.LambplanTerminal },
  { id: '14', value: 'SOUTHDOWN', db: Database.LambplanTerminal },
  { id: '19', value: 'SUFFOLK', db: Database.LambplanTerminal },
  { id: '42', value: 'SUFFOLK CANADA', db: Database.LambplanTerminal },
  { id: '17', value: 'TEXEL', db: Database.LambplanTerminal },
  { id: '37', value: 'TEXEL DOWNS', db: Database.LambplanTerminal },
  { id: '24', value: 'ULTRA WHITE', db: Database.LambplanTerminal },
  { id: '47', value: 'WHITE DORPERS', db: Database.LambplanTerminal },
  { id: '23', value: 'WHITE SUFFOLK', db: Database.LambplanTerminal },
  { id: '12', value: 'WILTIPOLL', db: Database.LambplanTerminal },
  { id: '09', value: 'WILTSHIRE HORN', db: Database.LambplanTerminal },
  { id: 'XB', value: 'XBRED', db: Database.LambplanTerminal },
  // CL - Shedders
  { id: '25', value: 'AUSTRALIAN WHITES', db: Database.LambplanShedders },
  { id: 'CS', value: 'COMPOSITE SHEDDING', db: Database.LambplanShedders },
  { id: '40', value: 'DORPER', db: Database.LambplanShedders },
  { id: '24', value: 'ULTRA WHITE', db: Database.LambplanShedders },
  { id: '47', value: 'WHITE DORPERS', db: Database.LambplanShedders },
  { id: '12', value: 'WILTIPOLL', db: Database.LambplanShedders },
  { id: '09', value: 'WILTSHIRE HORN', db: Database.LambplanShedders },
  // CL - Maternal
  { id: '06', value: 'BOND', db: Database.LambplanMaternal },
  { id: '39', value: 'BOOROOLA', db: Database.LambplanMaternal },
  { id: '02', value: 'BORDER LEICESTER', db: Database.LambplanMaternal },
  { id: 'CM', value: 'COMPOSITE MATERNALS', db: Database.LambplanMaternal },
  { id: 'CS', value: 'COMPOSITE SHEDDING', db: Database.LambplanMaternal },
  { id: '15', value: 'COOPWORTH', db: Database.LambplanMaternal },
  { id: '03', value: 'CORRIEDALE', db: Database.LambplanMaternal },
  { id: '49', value: 'DAMARA', db: Database.LambplanMaternal },
  { id: '38', value: 'EAST FRIESIAN', db: Database.LambplanMaternal },
  { id: '31', value: 'ENGLISH LEICESTER', db: Database.LambplanMaternal },
  { id: '43', value: 'FINN LEICESTERS', db: Database.LambplanMaternal },
  { id: '22', value: 'FINNSHEEP', db: Database.LambplanMaternal },
  { id: '07', value: 'GROMARK', db: Database.LambplanMaternal },
  { id: '08', value: 'HYFER', db: Database.LambplanMaternal },
  { id: '82', value: 'NZ BORDER LEICESTER', db: Database.LambplanMaternal },
  { id: '75', value: 'NZ COOPWORTH', db: Database.LambplanMaternal },
  { id: '83', value: 'NZ CORRIEDALE', db: Database.LambplanMaternal },
  { id: '92', value: 'NZ FINNSHEEP', db: Database.LambplanMaternal },
  { id: '41', value: 'NZ ROMNEY', db: Database.LambplanMaternal },
  { id: '32', value: 'PERENDALE', db: Database.LambplanMaternal },
  { id: '18', value: 'ROMNEY', db: Database.LambplanMaternal },
  { id: 'SI', value: 'SHEEP IMPROVEMENT LIMITED', db: Database.LambplanMaternal },
  { id: '23', value: 'WHITE SUFFOLK', db: Database.LambplanMaternal },
  { id: 'XB', value: 'XBRED', db: Database.LambplanMaternal },
  // CL - Corriedale
  { id: '03', value: 'CORRIEDALE', db: Database.LambplanCorriedale },
  { id: '83', value: 'NZ CORRIEDALE', db: Database.LambplanCorriedale },
  // CL - First cross sire breeds
  { id: '02', value: 'BORDER LEICESTER', db: Database.LambplanFirstCross },
  { id: '38', value: 'EAST FRIESIAN', db: Database.LambplanFirstCross },
  // *TEMA* End
];
